const STAR_RATINGS = Object.freeze({
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
});

const normalizeOrigin = (value) => String(value || '').trim().toLowerCase();

const getScore = (feedback) => {
  const score = Number(feedback?.nota);
  return Number.isFinite(score) && score > 0 ? score : null;
};

const getPeriodStart = (period) => {
  if (!period || period === 'all') return null;
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  if (period === 'today') return start;
  if (period === 'last7') start.setDate(start.getDate() - 6);
  else if (period === 'last15') start.setDate(start.getDate() - 14);
  else if (period === 'month') start.setDate(1);
  else return null;
  return start;
};

export const mapGoogleReviewToFeedback = (review = {}) => {
  const reviewId = String(review.reviewId || review.name || '').trim();
  const score = STAR_RATINGS[review.starRating] || Number(review.starRating || 0) || null;
  return {
    id: `google:${reviewId}`,
    cliente_nome: review.reviewer?.displayName || 'Usuário do Google',
    cliente_telefone: null,
    cliente_whatsapp_link: null,
    nota: score,
    comentario: String(review.comment || '').trim(),
    criado_em: review.createTime || review.updateTime || null,
    atualizado_em: review.updateTime || null,
    origem: 'google',
    classificacoes: [],
    pendencia_atendida: false,
    somente_leitura: true,
    google_live: true,
    google_review_id: reviewId,
    google_reply: review.reviewReply || null,
  };
};

export const mergeGoogleFeedbackPages = (current = [], reviews = []) => {
  const merged = new Map(current.map((feedback) => [String(feedback.id), feedback]));
  reviews.map(mapGoogleReviewToFeedback).forEach((feedback) => {
    if (feedback.id !== 'google:') merged.set(String(feedback.id), feedback);
  });
  return Array.from(merged.values());
};

export const filterFeedbacks = (feedbacks = [], filters = {}, options = {}) => {
  const start = getPeriodStart(filters.periodo);
  const selectedOrigin = normalizeOrigin(filters.origem);
  const selectedScore = filters.nota === 'all' ? null : Number(filters.nota);

  return feedbacks.filter((feedback) => {
    const origin = normalizeOrigin(feedback.origem);
    const score = getScore(feedback);
    const createdAt = feedback.criado_em ? new Date(feedback.criado_em) : null;

    if (start && (!createdAt || Number.isNaN(createdAt.getTime()) || createdAt < start)) return false;
    if (selectedOrigin && selectedOrigin !== 'all' && origin !== selectedOrigin) return false;
    if (Number.isFinite(selectedScore) && score !== selectedScore) return false;
    if (filters.sentimento === 'pos' && (!score || score < 4)) return false;
    if (filters.sentimento === 'neu' && score !== 3) return false;
    if (filters.sentimento === 'neg' && (!score || score > 2)) return false;
    if (options.attentionOnly && (
      feedback.somente_leitura
      || !score
      || score > 2
      || feedback.pendencia_atendida === true
    )) return false;
    return true;
  });
};

export const sortFeedbacks = (feedbacks = [], order = 'desc') => (
  [...feedbacks].sort((left, right) => {
    const leftTime = new Date(left.criado_em || 0).getTime() || 0;
    const rightTime = new Date(right.criado_em || 0).getTime() || 0;
    return order === 'asc' ? leftTime - rightTime : rightTime - leftTime;
  })
);

export const buildTransientSummary = (feedbacks = []) => {
  let scoreSum = 0;
  let scoreCount = 0;
  let positive = 0;
  let neutral = 0;
  let negative = 0;
  let pending = 0;

  feedbacks.forEach((feedback) => {
    const score = getScore(feedback);
    if (!score) return;
    scoreSum += score;
    scoreCount += 1;
    if (score >= 4) positive += 1;
    else if (score === 3) neutral += 1;
    else {
      negative += 1;
      if (!feedback.somente_leitura && feedback.pendencia_atendida !== true) pending += 1;
    }
  });

  return {
    total_feedbacks: feedbacks.length,
    media_nota: scoreCount ? scoreSum / scoreCount : null,
    por_sentimento: [
      { sentimento: 'positivo', total: positive },
      { sentimento: 'neutro', total: neutral },
      { sentimento: 'negativo', total: negative },
    ],
    pendencias_atencao: pending,
  };
};
